<template src="./unitDetails.template.html"></template>
<script async="" src="https://www.airbnb.com/embeddable/airbnb_jssdk"></script>

<script>
  // const socket = require('socket.io');


  export default {

    name: 'unitDetail',
    props: [],
    data() {
      return {
          unitData:{}
      };
    },
    methods: {
        unitDetails: function () {
                let vm = this;
                let obj = {
                    ModuleAction: "GetUnitDetailById",
                    PropertyId: vm.$route.params.PropertyId,
                    UnitId: vm.$route.params.UnitId,
                };
                let sucessCallback = function (response) {

                    if (response.data) {
                        console.log("GetUnitDetailById", response.data);
                        vm.unitData = response.data.UnitDataObj[0];



                    }

                },
                    failureCallback = function (error) {
                        console.log(error);
                    };



                vm.$store.state.sendApiRequest("beApi/GetUnitDetailById", "post", obj, sucessCallback, failureCallback);


            },

    },
    computed: {
        isVaildSubDomain() {
                let vm = this;
                return vm.$store.state.isValidDomainOrNot;
            }
    },
    created() {
    },
    watch: {
    },
    mounted() {
      let vm = this;
      vm.unitDetails();

    }
  }

</script>



// WEBPACK FOOTER //
// src/components/unitDetails/unitDetails.vue